import React from "react";
import "./Comparison.css";

const rows = [
  {
    traditional: "Reprinting increases paper waste and cost",
    nfc: "One reusable NFC card saves long-term costs",
  },
  {
    traditional: "No analytics or engagement tracking",
    nfc: "Track profile views and customer engagement",
  },
  {
    traditional: "Becomes outdated after printing",
    nfc: "Update details anytime instantly",
  },
  {
    traditional: "Shares limited contact information",
    nfc: "Share socials, payments, website, and more",
  },
  {
    traditional: "Easily lost or ignored",
    nfc: "Creates a smart and modern impression",
  },
];

const CrossIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" className="cmp-icon cmp-icon--cross">
    <circle cx="11" cy="11" r="11" fill="#FEE2E2" />
    <path d="M7.5 7.5l7 7M14.5 7.5l-7 7" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const CheckIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" className="cmp-icon cmp-icon--check">
    <circle cx="11" cy="11" r="11" fill="#DCFCE7" />
    <path d="M6.5 11.5l3 3 6-6" stroke="#16A34A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Comparison() {
  return (
    <section id="comparison" className="cmp-section">
      <div className="cmp-container">
        <div className="cmp-header">
          <h2 className="cmp-title">
            Your Last Business Card:{" "}
            <span className="cmp-title-accent">Smart, Digital & Always Updated</span>
          </h2>
          <p className="cmp-subtitle">
            Traditional cards get lost, damaged, or ignored after meetings.
            BusinessBay.io Digital NFC Business Cards keep your business just
            one tap away at all times.
          </p>
        </div>

        <div className="cmp-table-wrap">
          <div className="cmp-table">
            {/* Column headers */}
            <div className="cmp-col-header cmp-col-header--left">
              <span className="cmp-col-header-icon">📄</span>
              Traditional Paper Cards
            </div>
            <div className="cmp-col-header cmp-col-header--right">
              <span className="cmp-col-header-icon">⚡</span>
              BusinessBay.io NFC Cards
            </div>

            {/* Rows */}
            {rows.map((row, i) => (
              <React.Fragment key={i}>
                <div className={`cmp-cell cmp-cell--left${i % 2 === 0 ? " cmp-cell--even" : ""}`}>
                  <CrossIcon />
                  <span>{row.traditional}</span>
                </div>
                <div className={`cmp-cell cmp-cell--right${i % 2 === 0 ? " cmp-cell--even" : ""}`}>
                  <CheckIcon />
                  <span>{row.nfc}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
